
import {defineComponent, type PropType} from 'vue';
import {BreadcrumbItem} from "./models/BreadcrumbItem";

export default defineComponent({
    name: 'Breadcrumb',
    props: {
        customAriaLabel: {
            type: String,
            required: true
        },
        isInverse: {
            type: Boolean,
            required: false,
            default: false
        },
        breadcrumbItems: {
            type: Array as PropType<Array<BreadcrumbItem>>,
            required: true
        },
        label: {
            type: String,
            required: true
        }
    }
});
